<div class="container mx-auto">
    <div class="title">
        <h2>
            Please Select a Date
        </h2>
    </div>

    <!-- Booking Assistant Section (Hidden) -->
    <section class="booking-assistant" *ngIf="false" aria-labelledby="booking-assistant-title">
        <div class="assistant-glow-ambient" aria-hidden="true"></div>

        <div class="assistant-header-group">
            <div class="assistant-badge-icon">
                <mat-icon class="sparkle-svg-icon">auto_awesome</mat-icon>
            </div>
            <div class="assistant-header-text">
                <div class="assistant-pill-tag">
                    <span class="live-dot"></span>
                    <span>AI SMART APPOINTMENT ASSISTANT</span>
                </div>
                <h3 id="booking-assistant-title">Find an appointment</h3>
                <p>Tell us when you would like to visit (e.g. tomorrow morning, this Friday, or earliest available).</p>
            </div>
        </div>

        <div class="assistant-search-box">
            <div class="search-input-wrapper">
                <mat-icon class="search-leading-icon">schedule</mat-icon>
                <input 
                    type="text" 
                    class="assistant-query-input"
                    [(ngModel)]="assistantMessage" 
                    maxlength="1000"
                    (keyup.enter)="askBookingAssistant()" 
                    [disabled]="assistantLoading"
                    placeholder="Example: tomorrow morning, Friday afternoon..."
                    aria-label="Find an appointment time"
                />
                <button 
                    *ngIf="assistantMessage && !assistantLoading" 
                    type="button" 
                    class="clear-input-btn" 
                    (click)="clearAssistantMessage()"
                    aria-label="Clear input">
                    <mat-icon>close</mat-icon>
                </button>
            </div>
            <button 
                type="button" 
                class="assistant-find-btn" 
                (click)="askBookingAssistant()"
                [disabled]="assistantLoading || !assistantMessage.trim()"
                [class.is-loading]="assistantLoading">
                <mat-icon *ngIf="!assistantLoading" class="btn-send-icon">send</mat-icon>
                <span *ngIf="!assistantLoading">Find Slot</span>
                <span *ngIf="assistantLoading" class="btn-spinner-icon"></span>
                <span *ngIf="assistantLoading">Finding...</span>
            </button>
        </div>

        <!-- Quick Suggestion Chips -->
        <div class="assistant-quick-prompts">
            <span class="quick-label">Try asking:</span>
            <div class="chips-flex">
                <button 
                    type="button" 
                    class="quick-chip-button" 
                    *ngFor="let suggestion of quickSuggestions"
                    [disabled]="assistantLoading"
                    (click)="applyQuickPrompt(suggestion.query)">
                    <span class="chip-emoji">{{ suggestion.icon }}</span>
                    <span>{{ suggestion.label }}</span>
                </button>
            </div>
        </div>

        <!-- Loading State Indicator -->
        <div class="assistant-loading-box" *ngIf="assistantLoading">
            <div class="loading-pulse-ring"></div>
            <div class="loading-message-group">
                <span class="loading-title">Checking available appointment times...</span>
                <span class="loading-desc">Matching your schedule preferences with available doctor slots</span>
            </div>
        </div>

        <!-- Error Alert -->
        <div class="assistant-error-banner" *ngIf="assistantError" role="alert">
            <mat-icon class="error-banner-icon">error_outline</mat-icon>
            <div class="error-banner-body">
                <p>{{ assistantError }}</p>
            </div>
        </div>

        <!-- Response & Suggestions Card -->
        <div class="assistant-response-card" *ngIf="assistantReply">
            <div class="response-header">
                <div class="ai-reply-badge">
                    <mat-icon>psychology</mat-icon>
                    <span>Assistant Recommendation</span>
                </div>
            </div>
            <p class="reply-text-content">{{ assistantReply }}</p>

            <div class="missing-info-row" *ngIf="assistantMissingInformation.length">
                <span class="missing-info-title">Please also specify:</span>
                <span class="missing-info-tag" *ngFor="let item of assistantMissingInformation">
                    <mat-icon class="tag-icon">info</mat-icon>
                    <span>{{ item }}</span>
                </span>
            </div>

            <!-- Featured Suggested Slot Card -->
            <div class="suggested-slot-feature" *ngIf="suggestedSlot">
                <div class="slot-feature-info">
                    <div class="slot-feature-pills">
                        <span class="match-badge">✨ Best Matched Slot</span>
                        <span class="seats-badge" *ngIf="suggestedSlot.available_slot_count">
                            {{ suggestedSlot.available_slot_count }} slots available
                        </span>
                    </div>
                    <div class="slot-feature-time">
                        <mat-icon class="time-ico">alarm</mat-icon>
                        <span class="time-val">{{ suggestedSlot.start_time | date: 'h:mm a' }} – {{ suggestedSlot.end_time | date: 'h:mm a' }}</span>
                    </div>
                    <div class="slot-feature-date">
                        <mat-icon class="date-ico">event</mat-icon>
                        <span>{{ suggestedSlot.start_time | date: 'EEEE, MMMM d, y' }}</span>
                    </div>
                </div>
                <div class="slot-feature-action">
                    <button type="button" class="choose-slot-cta" (click)="chooseSuggestedSlot()">
                        <span>Select Suggested Slot</span>
                        <mat-icon>arrow_forward</mat-icon>
                    </button>
                </div>
            </div>

            <!-- Hint if slot is on another day -->
            <div class="suggested-slot-hint" *ngIf="assistantSuggestedSlotId && !suggestedSlot">
                <mat-icon class="hint-ico">calendar_month</mat-icon>
                <span>The suggested time is on a different date. Please browse the calendar below to view that date's slots.</span>
            </div>
        </div>
    </section>

    <div class="grid sm:grid-cols-1 md:grid-cols-1 lg:grid-cols-2 gap-4">
        <div class="">
            <mat-card class="slot-calendar">
                <mat-calendar (selectedChange)="onSelected($event)" [startAt]="startDate" [dateClass]="dateClass"
                    [(selected)]="selected" (monthSelected)="monthSelected($event)" #myCalendar></mat-calendar>
            </mat-card>
        </div>
        <div *ngIf="isSlotsLoaded && slots?.length > 0 && selected !== ''" class="mt-5 lg:mt-0">
            <div class="slots-list sm:ml-0 md:ml-0 lg:ml-3">
                <mat-list>
                    <div class="text-center slot-title" mat-subheader>Available slots on {{selected | date:'MMMM
                        d,YYYY'}}</div>
                    <mat-divider></mat-divider>
                    <div *ngFor="let slot of slots">
                        <div class="slots flex justify-between items-center">
                            <mat-list-item [disabled]="slot.blocked || slot.is_break || slot.slotsLimited">
                                <mat-icon matListItemIcon>access_time_filled</mat-icon>
                                <div *ngIf="!slot.blocked && !slot.is_break" class="font-bold slot-time"
                                    matListItemTitle>{{slot.start_time | date: 'h:mm a'}} -
                                    {{slot.end_time | date: 'h:mm a'}}
                                </div>
                                <div *ngIf="!slot.blocked && slot.is_break" class="font-bold slot-time"
                                    matListItemTitle>{{slot.start_time | date: 'h:mm a'}} -
                                    {{slot.end_time | date: 'h:mm a'}}
                                </div>
                                <div *ngIf="slot.blocked && !slot.is_break" class="font-bold slot-time"
                                    matListItemTitle>{{slot.start_time | date: 'h:mm a'}} -
                                    {{slot.end_time | date: 'h:mm a'}}
                                </div>
                                <div *ngIf="!slot.blocked && !slot.is_break" matListItemLine class="slot-count">
                                    {{slot.available_slot_count}} slots
                                    available</div>
                                <div *ngIf="slot.blocked && !slot.is_break" matListItemLine class="slot-count">
                                    <span>{{slots.title !== "" ? 'Slots Blocked' : slot.title}}</span>
                                </div>
                                <div *ngIf="!slot.blocked && !slot.is_break && slot.slotsLimited" matListItemLine
                                    class="slot-count">
                                    <span>Sorry! We have only {{slot.available_slot_count}} slots available. Please
                                        select another date</span>
                                </div>
                                <div *ngIf="!slot.blocked && slot.is_break" matListItemLine class="slot-count">
                                    <span>{{slots.title !== "" ? 'Break' : slot.title}}</span>
                                </div>
                            </mat-list-item>
                            <button spinnerButton [loading]="isLoading" mat-raised-button color="primary"
                                (click)="slotRegistration(slot)"
                                *ngIf="!slot.blocked && !slot.is_break && !slot.slotsLimited">
                                <span class="text-white" *ngIf="!isLoading">Book</span>
                            </button>
                        </div>
                        <mat-divider></mat-divider>
                    </div>
                </mat-list>
            </div>
        </div>
        <div *ngIf="isSlotsLoaded && slots?.length < 1 && selected !== ''" class="flex justify-center items-center">
            <p>Sorry.! No slots available for this date</p>
        </div>
        <div *ngIf="selected == ''" class="flex justify-center items-center">
            <p>Please select a date for booking.</p>
        </div>
        <div *ngIf="!isSlotsLoaded" class="mt-5 lg:mt-0">
            <div class="slots-list sm:ml-0 md:ml-0 lg:ml-3">
                <mat-list>
                    <div class="text-center slot-title my-3" mat-subheader>
                        <ngx-skeleton-loader count="1" appearance="line"
                            [theme]="{height: '30px', margin:'0'}"></ngx-skeleton-loader>
                    </div>
                    <div *ngFor="let slot of loaderSlots">
                        <div class="slots flex justify-between items-center">
                            <mat-list-item>
                                <div class="font-bold slot-time" matListItemTitle>
                                    <ngx-skeleton-loader [theme]="{height: '21px', margin:'5% 0'}" count="1"
                                        appearance="line"></ngx-skeleton-loader>
                                </div>
                            </mat-list-item>
                        </div>
                    </div>
                </mat-list>
            </div>
        </div>
    </div>
</div>
